import { Model } from '@/models/Model';

export class SubColor extends Model
{
  protected $name: string = 'SubColor';
  protected $endpoint: string = '/sub-colors';
  protected $fillable: string[] = ['name', 'short_name', 'color'];

  public name?: string;
  public short_name?: string;
  public id?: string;
  public color?: string;
}
